import _ from 'lodash'

import canSeeIntegration from 'modules/marketplace/lib/canSeeIntegration'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'
import type { CompanyInstallations } from 'modules/marketplace/store/collections/companyInstallations'
import PayrollIntegration from 'modules/payroll_integrations/lib/catalog'

class IntegrationDescriptor {
  enabled(installedIntegrations: CompanyInstallations) {
    return AVAILABLE_INTEGRATIONS(installedIntegrations)
      .filter((integration) => integration.hasFeature())
      .map((integration) => _.pick(integration, ['name', 'label']))
  }
}

const AVAILABLE_INTEGRATIONS = (installedIntegrations: CompanyInstallations) => [
  {
    name: PayrollIntegration.a3nom,
    hasFeature: () => canSeeIntegration(integrationCodes.a3nom, installedIntegrations),
  },
  {
    name: PayrollIntegration.a3innuva,
    hasFeature: () => canSeeIntegration(integrationCodes.a3innuva, installedIntegrations),
  },
  {
    name: PayrollIntegration.zucchetti,
    hasFeature: () => canSeeIntegration(integrationCodes.zucchetti, installedIntegrations),
  },
  {
    name: PayrollIntegration.sage100,
    hasFeature: () => canSeeIntegration(integrationCodes.sage100, installedIntegrations),
  },
  {
    name: PayrollIntegration.datevApi,
    hasFeature: () => canSeeIntegration(integrationCodes.datev_api, installedIntegrations),
  },
  {
    name: PayrollIntegration.datevLugApi,
    hasFeature: () => canSeeIntegration(integrationCodes.datev_lug_api, installedIntegrations),
  },
  {
    name: PayrollIntegration.datevLauds,
    hasFeature: () =>
      canSeeIntegration(integrationCodes.datev_lauds_factorial, installedIntegrations),
  },
  {
    name: PayrollIntegration.gispaghe,
    hasFeature: () => canSeeIntegration(integrationCodes.gispaghe, installedIntegrations),
  },
  {
    name: PayrollIntegration.jobSistemi,
    hasFeature: () => canSeeIntegration(integrationCodes.job_sistemi, installedIntegrations),
  },
]

const singleton = new IntegrationDescriptor()

export default singleton
